
























































































































































import { Vue, Component, Lifecycle, Watch, Prop, p } from "av-ts";

import Fetcher from "../../services/Fetcher";
import UserService from "../../services/UserService";
import QuestionService from "../../services/QuestionService";
import { serverToLocal, isAdmin } from "../../util";

import { IOfferingUser, IReport, IReportAggregate, IServerReportFull,
    IServerReport, IServerReportAggregate } from "../../interfaces/models";

const _MODAL_NAME = "report_modal";
const _RESOLVE_MODAL_NAME = "resolve_modal";

@Component()
export default class ReportedQuestions extends Vue {
    itemsPerPage = 10;
    pageIndex = 1;
    pCourseCode: string = "";
    pReports: IReport[][] = [];
    reportAggregates: IReportAggregate[] = [];
    pNumReports: number = 0;
    pModalAuthor: string = "";
    pModalDate: string = "";
    pModalReason: string = "";
    pModalResolve: number = 0;
    
    reportCountOld: number = 2;
    reportCountString: string = "2";
    @Prop reportCountProp = p<string>({});
    useProp: boolean = true;

    get modalAuthor() {
        return this.pModalAuthor;
    }

    set modalAuthor(newAuth: string) {
        this.pModalAuthor = newAuth;
    }
    get modalDate() {
        return this.pModalDate;
    }

    set modalDate(newDate: string) {
        this.pModalDate = newDate;
    }
    get modalReason() {
        return this.pModalReason;
    }

    get reportCount() {
        if (this.useProp && this.reportCountProp != undefined) {
            this.useProp = false;
            this.reportCountString = this.reportCountProp;
        }
        if (this.reportCountString == "") {
            return this.reportCountOld;
        }
        this.reportCountOld = Math.floor(parseFloat(this.reportCountString));
        return this.reportCountOld;
    }

    set reportCount(count: number) {
        this.reportCountString = count.toString();
        this.reportCountOld = count;
    }

    set modalReason(newReason: string) {
        this.pModalReason = newReason;
    }

    get reports() {
        return this.pReports;
    }

    set reports(newReports: IReport[][]) {
        this.pReports = newReports;
    }

    get numReports() {
        return this.pNumReports;
    }

    set numReports(newNum: number) {
        this.pNumReports = newNum;
    }

    get modalResolve() {
        return this.pModalResolve;
    }

    set modalResolve(newNum: number) {
        this.pModalResolve = newNum;
    }

    updateReports(serverReport: IServerReportFull) {
        let reportList: IReport[][] = [];
        for (let i = 1; i < serverReport.reports.length; i++) {
            reportList.push([]);
            let report: IServerReport[] = <IServerReport[]>serverReport.reports[i];
            report.forEach(rep => {
                let reasons: string = "";
                rep.reasons.forEach(reason => {
                    reasons += reason.reasonText + ". ";
                });
                reasons = reasons.trim();
                let newRep: IReport = {
                    createdAt: serverToLocal(rep.createdAt),
                    author: rep.author,
                    reason: reasons
                };
                reportList[i-1].push(newRep);
            });
        }
        this.reports = reportList;
    };

    updateOfferingUser(offeringUser: IOfferingUser) {
        if (!isAdmin(offeringUser.roles)) {
            this.$router.push("error/403");
        }
        this.pCourseCode = offeringUser.offering.courseCode;
    }

    updateReportAggregates(serverReport: IServerReportFull) {
        this.reportAggregates = [];
        let aggregateList: IServerReportAggregate[] = <IServerReportAggregate[]>serverReport.reports[0];
        aggregateList.forEach(agg => {
            let newAgg: IReportAggregate = {
                questionID: agg.questionID,
                totalReports: agg.totalReports,
                lastReport: serverToLocal(agg.lastReport)
            };
            this.reportAggregates.push(newAgg);
        });
        this.pNumReports = this.reportAggregates.length;
    }

    getShortReason(reason: String) {
        if (reason.length > 20) {
            return reason.substring(0, 20) + "...";
        }
        return reason;
    }

    resolveReport(id: number) {
        QuestionService.resolveReport(id).then(function() {
            Fetcher.forceUpdate();
        });
        this.closeDialog();
    }

    openDialog(i: number, j:any) {
        this.modalAuthor = this.reports[i][j]["author"];
        this.modalDate = this.reports[i][j]["createdAt"];
        this.modalReason = this.reports[i][j]["reason"];
        const modal = this.$refs[_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    };

    openResolveDialog(i: number) {
        const modal = this.$refs[_RESOLVE_MODAL_NAME] as any;
        if (modal) {
            this.modalResolve = i;
            requestAnimationFrame(() => modal.open());
        }
    }

    closeDialog() {
        (this.$refs[_MODAL_NAME] as any).close();
        (this.$refs[_RESOLVE_MODAL_NAME] as any).close();
    }

    viewQuestion(id: number) {
        let query = { "reportCount": this.reportCount.toString() };
        let params = { "id": id.toString(), "returnTo": "reported" };
        this.$router.push({ name: "questionWrapper", params: params, query: query });
    }

    @Watch("reportCount")
    updateReportCount(newCount: number, oldCount: number) {
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: oldCount })
            .off(this.updateReports);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: newCount })
            .on(this.updateReports);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: oldCount })
            .off(this.updateReportAggregates);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: newCount })
            .on(this.updateReportAggregates);
    }

    @Lifecycle
    created() {
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateOfferingUser);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: 2 })
            .on(this.updateReportAggregates);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: 2 })
            .on(this.updateReports);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateOfferingUser);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: this.reportCount })
            .off(this.updateReportAggregates);
        Fetcher.get(QuestionService.getReportAggregates, { reportCount: this.reportCount })
            .off(this.updateReports);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/ReportedQuestions.vue